import { formatDateOrDash, formatDateTimeOrDash } from '#/utils/date';

export function mapSignReceiptMeta(detail) {
  return {
    code: detail?.signReceiptNo || '-',
    status: detail?.status || '',
    signReceiptDate: formatDateOrDash(detail?.signReceiptDate),
    customerName: detail?.customerName || '',
    contactName: detail?.contactName || '',
    phone: detail?.phone || '',
    fax: detail?.fax || '',
    taxId: detail?.taxId || '',
    address: detail?.address || '',
    remark: detail?.remark || '',
    createDate: formatDateTimeOrDash(detail?.record?.createdAt),
    reviseDate: formatDateTimeOrDash(detail?.record?.updatedAt),
    establishedAt: formatDateTimeOrDash(detail?.history?.establishedAt),
    completedAt: formatDateTimeOrDash(detail?.history?.completedAt),
    cancelledAt: formatDateTimeOrDash(detail?.history?.cancelledAt),
    lineCount: detail?.lines?.length ?? 0,
  };
}

/**
 * Detail lines → form：只保留 repairItemIds；顯示列另存 selectedItems。
 */
export function mapSignReceiptDetailToFormValues(detail) {
  const lines = detail?.lines ?? [];
  return {
    signReceiptNo: detail?.signReceiptNo ?? '',
    signReceiptDate: detail?.signReceiptDate ?? '',
    /** 客戶關聯（customer_id）；聯絡人仍為 UI 暫存。 */
    customerId: detail?.customerId ?? detail?.customer?.id ?? '',
    contactId: '',
    customerName: detail?.customerName ?? '',
    contactName: detail?.contactName ?? '',
    phone: detail?.phone ?? '',
    fax: detail?.fax ?? '',
    taxId: detail?.taxId ?? '',
    address: detail?.address ?? '',
    remark: detail?.remark ?? '',
    repairItemIds: lines
      .map((line) => line?.repairItemId)
      .filter(Boolean),
  };
}

export function mapDetailLinesToSelectedItems(detail) {
  return (detail?.lines ?? []).map((line) => ({
    id: line?.repairItemId,
    repairItemId: line?.repairItemId,
    serialNo: line?.serialNo ?? '',
    productCode: line?.productCode ?? '',
    itemName: line?.itemName ?? '',
    problemDescription: line?.problemDescription ?? '',
    accessories: line?.accessories ?? '',
    repairReportNo: line?.repairReportNo ?? '',
    repairReportStatus: line?.repairReportStatus ?? '',
  })).filter((item) => item.id);
}

/**
 * Create／Update write payload。只送 repairItemIds；禁 SN／reportId。
 * customerId：Create 有選才送；Update 只在與載入值不同時送（清空＝null）。
 * **不送** contactId。
 */
export function buildSignReceiptWritePayload(values, {
  updatedAt = null,
  isEdit = false,
  originalCustomerId = '',
} = {}) {
  const customerId = values?.customerId || '';
  const payload = {
    signReceiptDate: values?.signReceiptDate || null,
    customerName: values?.customerName || null,
    contactName: values?.contactName || null,
    phone: values?.phone || null,
    fax: values?.fax || null,
    taxId: values?.taxId || null,
    address: values?.address || null,
    remark: values?.remark || null,
    repairItemIds: (values?.repairItemIds ?? []).filter(Boolean),
  };

  if (!isEdit) {
    payload.signReceiptNo = values?.signReceiptNo || null;
    if (customerId) {
      payload.customerId = customerId;
    }
  } else if (customerId !== (originalCustomerId || '')) {
    payload.customerId = customerId || null;
  }

  if (updatedAt) {
    payload.updatedAt = updatedAt;
  }

  return payload;
}
